/**
 * Single point of access for build-time configuration.
 *
 * Values come from the `.env.development` / `.env.test` / `.env.production`
 * files (see `envPrefix` in `vite.config.ts`) and are inlined into the bundle at
 * build time, so nothing here can be changed at runtime. Import from this module
 * rather than reading `import.meta.env` directly — it keeps the set of expected
 * variables in one place and gives them real types.
 */

export const apiMode = import.meta.env.REACT_APP_API;
export const appEnv = import.meta.env.REACT_APP_ENV;

export const authHostLive = import.meta.env.REACT_APP_AUTH_HOST;
export const authHostPreLive = import.meta.env.REACT_APP_AUTH_HOST_PRE_LIVE;

export const cognitoClientIdLive = import.meta.env.REACT_APP_COGNITO_CLIENT_ID;
export const cognitoClientIdPreLive = import.meta.env
  .REACT_APP_COGNITO_CLIENT_ID_PRE_LIVE;
export const cognitoUserPoolIdLive = import.meta.env
  .REACT_APP_COGNITO_USER_POOL_ID;
export const cognitoUserPoolIdPreLive = import.meta.env
  .REACT_APP_COGNITO_USER_POOL_ID_PRE_LIVE;

export const intercomAppId = import.meta.env.REACT_APP_INTERCOM_APP_ID;
export const mixpanelToken = import.meta.env.REACT_APP_MIXPANEL_TOKEN;

/** True for `vite build` output, false for the dev server. Was `NODE_ENV === 'production'`. */
export const isProductionBuild = import.meta.env.PROD;

/** True for the deployed production environment, as opposed to a production *build*. */
export const isProductionEnv = appEnv === 'production';
